import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { PLAINTIFF_UPDATE_REPORT_QUERY } from '../../../graphql.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import '../Custom.css'
import { Link } from 'react-router-dom'

const PLAINTIFF_UPDATE_REPORT = gql(PLAINTIFF_UPDATE_REPORT_QUERY)

export default function PlaintiffUpdate({ location }) {
  console.log('PlaintiffUpdate rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, PLAINTIFF_UPDATE_REPORT, 'plaintiffUpdate', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = []
    for (let i = 0; i < results.reportData.length; i++) {
      let row = []
      row.push(<td style={{ textAlign: 'right'}} key={-1}>{i+1}</td>)
      for (let j = 2; j < results.reportData[i].length; j++) {
        row.push(<td style={{ textAlign: 'right'}} key={j}>{results.reportData[i][j]}</td>)
      }
      row.push(<td key={-3} style={{verticalAlign: 'middle', width: 'auto'}}><Link to={`/object/${results.reportData[i][0]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View Plaintiff</Button></Link></td>)
      row.push(<td key={-2} style={{verticalAlign: 'middle', width: 'auto'}}><Link to={`/object/${results.reportData[i][1]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View Case</Button></Link></td>)
      resultRows.push(<tr key={i}>{row}</tr>)
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/plaintiffUpdate/plaintiff_update', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Plaintiff Update'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}